<template>
    <div>
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-archive</v-icon>
                                Historiales
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="historialEstado"
                                    label="Historiales"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Insertados', value: '2' },
                                        { text: 'Modificados', value: '3' },
                                        { text: 'Eliminados', value: '4' },
                                        { text: 'Deshabilitados', value: '5' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadRegistro()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-menu
                                    v-model="filtroRegistros"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-historial
                                        v-if="filtroRegistros"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-historial>
                                </v-menu>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat :loading="loadingHistoryTimeLine">
                                            <v-icon medium v-on="on" @click="loadHistory">fa-calendar-o</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Historial de cambios</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon @click="showTreeViewElements = true">
                                            <v-icon medium v-on="on">fa-folder-open</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Buscar registro</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="HISTORIALES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr :class="props.item.estado === 0 ? 'red--text' : ''">
                                        <td>{{ getClassName(props.item.class) }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{ getRegistroType(props.item) }}
                                            </v-chip>
                                        </td>
                                        <td>{{ props.item.message }}</td>
                                        <td>
                                            <v-icon :disabled="true">fa-calendar</v-icon>
                                            {{ props.item.created_at }}
                                            (
                                            <v-icon :disabled="true">fa-user</v-icon>
                                            {{ props.item.created_by ? props.item.created_by.username : "-" }}
                                            )
                                        </td>
                                        <td>
                                            <v-icon :disabled="true">fa-calendar</v-icon>
                                            {{ props.item.updated_at }}
                                            (
                                            <v-icon :disabled="true">fa-user</v-icon>
                                            {{ props.item.updated_by ? props.item.updated_by.username : "-" }}
                                            )
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="primary"
                                                            :disabled="loading"
                                                            @click="expandItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">?</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Valor del registro</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="text-xs-center">
                                            {{ props.item.values }}
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen historiales registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <records-select v-if="showTreeViewElements" @formCanceled="showTreeViewElements = false"></records-select>

        <time-line
            v-if="showHistoryTimeLine"
            :data="dataHistoryTimeLine"
            :element="'Registro'"
            @formCanceled="showHistoryTimeLine = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
const CustomFilterHistorial = () =>
    import(/* webpackChunkName: "filtro-historial" */ "@/components/widgets/custom-filter-historial/custom-filter-historial")
const TimeLine = () =>
    import(/* webpackChunkName: "history-time-line" */ "@/components/widgets/records-time-line/time-line")
const RecordsSelect = () =>
    import(/* webpackChunkName: "records-select" */ "@/components/widgets/records-time-line/records-select")

export default {
    components: { TimeLine, RecordsSelect, CustomFilterHistorial },
    props: {
        //estado de los registros a cargar del back
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        headers: [
            { text: "Nombre", value: "class" },
            { text: "Tipo", value: "type" },
            { text: "Mensaje", value: "message" },
            { text: "Creado", value: "created_by" },
            { text: "Modificado", value: "updated_by" }
        ],

        totalItems: 0,

        //estado de los registros a cargar del back
        historialEstado: "1",

        //filtro de regitros
        filtroRegistros: false,
        customFilter: null,
        activeFilters: 0,

        // records treeview
        showTreeViewElements: false,

        //historiales time line
        showHistoryTimeLine: false,
        dataHistoryTimeLine: null,
        loadingHistoryTimeLine: false,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_HISTORIALES", { historialEstado: estado, customfilter: this.customfilter })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        expandItem(props) {
            props.expanded = !props.expanded
        },

        loadRegistro() {
            this.activeFilters = 0
            this.loadData(this.historialEstado)
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroRegistros = false
                this.historialEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.historialEstado, this.customfilter)
            } else {
                this.historialEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.historialEstado, this.customfilter)
                this.filtroRegistros = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        loadHistory() {
            this.loadingHistoryTimeLine = true

            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store.dispatch("LOAD_HISTORIALES_TIME_LINE", { class: null, class_id: null }).then(response => {
                if (response) {
                    this.dataHistoryTimeLine = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                    this.showHistoryTimeLine = true
                    this.loadingHistoryTimeLine = false
                } else this.loadingHistoryTimeLine = false
            })
        },

        getRegistroType(record) {
            switch (record.type) {
                case "created":
                    return "Insertado"
                case "updated":
                    return "Modificado"
                case "deleted":
                    return "Eliminado"
                case "disabled":
                    return "Deshabilitado"
            }
        },

        getClassName(clase) {
            return clase.slice(clase.lastIndexOf(`\\`) + 1)
        },

        getChipColor(record) {
            switch (record.type) {
                case "created":
                    return "success lighten-1"
                case "updated":
                    return "orange lighten-1"
                case "deleted":
                    return "red lighten-1"
                case "disabled":
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "orange lighten-1"
                case "4":
                    return "red lighten-1"
                case "5":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["HISTORIALES"]),

        pagination: {
            get: function() {
                return this.$store.getters.HISTORIALES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_HISTORIALES_PAG", value)
            }
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.historialEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.historialEstado, this.customfilter)
            },
            deep: true
        }
    }
}
</script>

<style scoped></style>
